
import React from 'react';
import { Construction, Wrench, Clock } from 'lucide-react';

const UnderConstruction = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 flex items-center justify-center p-4">
      <div className="max-w-2xl mx-auto text-center">
        {/* Animated construction icons */}
        <div className="flex justify-center space-x-4 mb-8">
          <Construction className="h-16 w-16 text-yellow-500 animate-bounce" />
          <Wrench className="h-16 w-16 text-orange-500 animate-pulse" />
          <Clock className="h-16 w-16 text-blue-500 animate-spin" style={{ animationDuration: '3s' }} />
        </div>

        {/* Main heading */}
        <h1 className="text-6xl font-bold text-white mb-4 animate-fade-in">
          Under Construction
        </h1>
        
        {/* Subtitle */}
        <h2 className="text-2xl text-gray-300 mb-8 animate-fade-in" style={{ animationDelay: '0.2s' }}>
          Estamos trabajando en algo increíble
        </h2>

        {/* Description */}
        <p className="text-lg text-gray-400 mb-12 max-w-lg mx-auto animate-fade-in" style={{ animationDelay: '0.4s' }}>
          Nuestro equipo está mejorando la experiencia del compresor de imágenes. 
          Vuelve pronto para descubrir las nuevas funcionalidades.
        </p>

        {/* Progress bar animation */}
        <div className="max-w-md mx-auto mb-8 animate-fade-in" style={{ animationDelay: '0.6s' }}>
          <div className="bg-gray-700 rounded-full h-4 overflow-hidden">
            <div className="bg-gradient-to-r from-blue-500 to-purple-600 h-full rounded-full animate-pulse" 
                 style={{ width: '73%' }}>
            </div>
          </div>
          <p className="text-gray-400 text-sm mt-2">Progreso: 73%</p>
        </div>

        {/* Contact info */}
        <div className="text-gray-500 animate-fade-in" style={{ animationDelay: '0.8s' }}>
          <p className="text-sm">
            ¿Tienes preguntas? Contáctanos en{' '}
            <a href="mailto:info@compresorjpeg.com" className="text-blue-400 hover:text-blue-300 transition-colors">
              info@compresorjpeg.com
            </a>
          </p>
        </div>

        {/* Subtle admin access hint */}
        <div className="mt-16 opacity-20 hover:opacity-50 transition-opacity">
          <p className="text-xs text-gray-600">Admin Access</p>
        </div>
      </div>
    </div>
  );
};

export default UnderConstruction;
